import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';
import { api } from '../../utils/endpoints';
import { ApiCallsService } from './network/api-calls.service';

@Injectable({
  providedIn: 'root'
})
export class CommonDataSharingService {

  private readonly SECRET_KEY: string = 'IM1s5OqAYE9XoNyr7txjPXiuDO2WoZCt';
  private readonly SECRET_IV: string = 'ST9KKWIeZtw0Onu1';
  agencyList: any = [];

  constructor(private _apiCalls: ApiCallsService) { }

  _getAgencyList(request: any) {
    return new Promise((resolve, reject) => {
      const encryptPayload: any = this.encryptData(request);
      this._apiCalls.post(api._agencyLists, encryptPayload).subscribe(({
        next: (res: any) => {
          const decryptResponse: any = this.decryptData(res);    // Decrypt api response
          resolve(decryptResponse);
        },
        error: (error: any) => console.log(error)
      }))
    });

  }

  encryptData(data: string): string {
    const secretKey = CryptoJS.enc.Utf8.parse(this.SECRET_KEY); // 32 bytes
    const iv = CryptoJS.enc.Utf8.parse(this.SECRET_IV); // 16 bytes
    // Convert data to JSON string
    const stringifyJsonData = JSON.stringify(data);

    // Encrypt the JSON string
    const encrypted = CryptoJS.AES.encrypt(
      CryptoJS.enc.Utf8.parse(stringifyJsonData), // Convert string to WordArray
      secretKey,
      {
        iv: iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    // Return encrypted data as a Base64 string
    return encrypted.toString();
  }

  decryptData(apiRes: string): string {
    const secretKey = CryptoJS.enc.Utf8.parse(this.SECRET_KEY); // 32 bytes
    const iv = CryptoJS.enc.Utf8.parse(this.SECRET_IV); // 16 bytes
    // Decrypt the encrypted text
    const decrypted = CryptoJS.AES.decrypt(apiRes, secretKey, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    });

    const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
    return JSON.parse(decryptedText); // Convert JSON string back to an object
  }
}
